import { useEffect, useState } from "react";
import styles from "./setup.module.css";
import { IUser, IUserUpdate } from "../../../../interfaces/user";

type Props = {
  user: IUser;
  selected: string;
  getUser: (token: string) => void;
};

const SetupPage = ({ user, selected, getUser }: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<IUser>({} as IUser);

  const onSaveUser = async (user: IUser) => {
    const getCookie = (name: string) => {
      const match = document.cookie.match(`(^|;)\\s*${name}=([^;]+)`);
      return match ? match[2] : null;
    };

    const token = getCookie("token");
    if (token) {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        if (!apiUrl) {
          console.error("Erro: API URL não definida.");
          return;
        }

        const bodyReq: IUserUpdate = {};
        if (user.firstname) bodyReq.firstname = user.firstname;
        if (user.lastname) bodyReq.lastname = user.lastname;
        if (user.email) bodyReq.email = user.email;
        if (user.phone) bodyReq.phone = user.phone;
        if (user.password) bodyReq.password = user.password;

        const response = await fetch(`${apiUrl}/users`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(bodyReq),
        });

        const resData = await response.json();

        if (!response.ok) {
          alert(
            `${resData.message} ${resData.details}` || "Erro ao salvar usuário."
          );
          return;
        }

        alert("Usuário salvo com sucesso.");

        return await getUser(token);
      } catch (error) {
        alert("Erro ao salvar usuário: " + error);
        return;
      }
    } else {
      alert("Erro: Token não encontrado.");
      return;
    }
  };

  const LoadingOverlay = () => (
    <div className={styles.loadingOverlay}>
      <div className={styles.spinner}></div>
    </div>
  );

  useEffect(() => {
    if (selected === "Configurações") {
      setLoading(true);
      const userData: IUser = {} as IUser;
      if (user.firstname) userData.firstname = user.firstname;
      if (user.lastname) userData.lastname = user.lastname;
      if (user.email) userData.email = user.email;
      if (user.phone) userData.phone = user.phone;

      setData({ ...userData, password: "" });
      setLoading(false);
    }
  }, [selected, user]);

  const onRenderForm = () => {
    return (
      <div className={`${styles.grid_list}`}>
        <div className={styles.form}>
          <div className={`${styles.form_input_div} ${styles.w20}`}>
            <label htmlFor="firstname" className={styles.form_label}>
              Nome:
            </label>
            <input
              id="firstname"
              className={styles.form_input}
              value={data?.firstname || ""}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setData({ ...data, firstname: e.target.value })
              }
            />
          </div>
          <div className={`${styles.form_input_div} ${styles.w20}`}>
            <label htmlFor="lastname" className={styles.form_label}>
              Sobrenome:
            </label>
            <input
              id="lastname"
              className={styles.form_input}
              value={data?.lastname || ""}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setData({ ...data, lastname: e.target.value })
              }
            />
          </div>
          <div className={`${styles.form_input_div} ${styles.w25}`}>
            <label htmlFor="email" className={styles.form_label}>
              Email:
            </label>
            <input
              id="email"
              className={styles.form_input}
              value={data?.email || ""}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setData({ ...data, email: e.target.value })
              }
            />
          </div>
          <div className={`${styles.form_input_div} ${styles.w15}`}>
            <label htmlFor="phone" className={styles.form_label}>
              Telefone:
            </label>
            <input
              id="phone"
              className={styles.form_input}
              value={data?.phone || ""}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setData({ ...data, phone: e.target.value })
              }
            />
          </div>
          <div className={`${styles.form_input_div} ${styles.w20}`}>
            <label htmlFor="password" className={styles.form_label}>
              Senha:
            </label>
            <input
              type="password"
              id="password"
              className={styles.form_input}
              value={data?.password || ""}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setData({ ...data, password: e.target.value })
              }
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {loading && <LoadingOverlay />}
      <section className={styles.setup}>
        <div className={styles.header}>
          <h4 className={styles.title}>Minhas Configurações</h4>
        </div>
        <div className={`${styles.list_container}`}>
          <div className={styles.page}>
            <div className={styles.container_title_div}>
              <h1 className={styles.container_title}>Meu Usuário</h1>
            </div>
            {onRenderForm()}
            <div className={`${styles.form_group_end}`}>
              <button
                type="submit"
                className={styles.action_btn_end}
                onClick={() => {
                  setLoading(true);
                  onSaveUser(data)
                    .then(() => setLoading(false))
                    .catch(() => setLoading(false));
                }}
                disabled={loading}
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SetupPage;
